'use strict';

//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************

//***********************************************************************************
//***********************************************************************************
//**** Material
//***********************************************************************************
//***********************************************************************************

import { cn_element_type } from './cn_element_type';

/**
 * @type {cn_material_type[]}
 */
export const CN_MATERIALS_TYPES = [];

export var CN_MATERIAL_TYPE_HEAVY_STRUCTURE = 0;
export var CN_MATERIAL_TYPE_LIGHT_STRUCTURE = 1;
export var CN_MATERIAL_TYPE_INSULATED_STRUCTURE = 2;
export var CN_MATERIAL_TYPE_INSULATOR = 3;
export var CN_MATERIAL_TYPE_FACING = 4;
export var CN_MATERIAL_TYPE_CEILING = 5;
export var CN_MATERIAL_TYPE_OTHER = 99;

export class cn_material_type extends cn_element_type {
    constructor(
        parent,
        name = 'Béton',
        code = 'concrete',
        conductivity = 0,
        density = 0,
        specific_heat = 0,
        type = CN_MATERIAL_TYPE_HEAVY_STRUCTURE,
        color = [200, 200, 200],
    ) {
        super(parent);
        this.class_name = 'cn_material_type';
        this.name = name;
        this.code = code;
        this.type = type;
        this.conductivity = conductivity;
        this.density = density;
        this.specific_heat = specific_heat;
        this.color = color;
        /** Indicates if material is user custom or building default */
        this.custom = false;
        /** {number} Potential fixed thickness */
        this.thickness = undefined;
        this.extension_data = {};
    }

    get code_label() {
        return cn_material_type.material_type_by_code(this.code).name;
    }

    get type_label() {
        switch (this.type) {
            case CN_MATERIAL_TYPE_HEAVY_STRUCTURE:
                return 'Structure lourde';
            case CN_MATERIAL_TYPE_LIGHT_STRUCTURE:
                return 'Structure légère';
            case CN_MATERIAL_TYPE_INSULATED_STRUCTURE:
                return 'Structure isolée';
            case CN_MATERIAL_TYPE_INSULATOR:
                return 'Isolant';
            case CN_MATERIAL_TYPE_FACING:
                return 'Parement';
            case CN_MATERIAL_TYPE_CEILING:
                return 'Faux-plafond';
            default:
                return 'Autre';
        }
    }

    //***********************************************************************************
    /**
     * Build default materials
     */
    static build_default_materials_types(building) {
        if (CN_MATERIALS_TYPES.length > 0) return;
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Béton', 'concrete', 2, 1250, 100, CN_MATERIAL_TYPE_HEAVY_STRUCTURE));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Parpaing', 'block', 0.5, 500, 1900, CN_MATERIAL_TYPE_HEAVY_STRUCTURE));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Brique', 'brick', 0.5, 900, 2000, CN_MATERIAL_TYPE_HEAVY_STRUCTURE, [150, 20, 20]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Pierre', 'stone', 2.5, 2700, 1000, CN_MATERIAL_TYPE_HEAVY_STRUCTURE, [182, 171, 136]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Bois', 'wood', 0.14, 500, 2500, CN_MATERIAL_TYPE_HEAVY_STRUCTURE, [165, 132, 80]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Acier', 'steel', 0.14, 500, 2500, CN_MATERIAL_TYPE_HEAVY_STRUCTURE, [70, 70, 70]));

        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Bois isolé', 'insulated_wood', 0.05, 520, 2500, CN_MATERIAL_TYPE_INSULATED_STRUCTURE, [165, 132, 80]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Béton isolé', 'insulated_concrete', 0.05, 500, 920, CN_MATERIAL_TYPE_INSULATED_STRUCTURE));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Acier isolé', 'insulated_steel', 0.05, 520, 2500, CN_MATERIAL_TYPE_INSULATED_STRUCTURE, [70, 70, 70]));

        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Isolant minéral', 'insulator', 0.04, 25, 1030, CN_MATERIAL_TYPE_INSULATOR, [236, 233, 183]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Isolant naturel', 'wood_fiber', 0.038, 160, 2100, CN_MATERIAL_TYPE_INSULATOR, [158, 220, 121]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Isolant synthétique', 'styrofoam', 0.037, 25, 1700, CN_MATERIAL_TYPE_INSULATOR, [255, 255, 255]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Lame d\'air', 'air_layer', 0.06, 1, 1, CN_MATERIAL_TYPE_INSULATOR));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Air', 'air', 0.025, 1, 1, CN_MATERIAL_TYPE_OTHER));

        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Enduit', 'cement', 1.15, 800, 900, CN_MATERIAL_TYPE_FACING));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Bardage', 'tiles', 0.14, 500, 2500, CN_MATERIAL_TYPE_FACING, [115, 138, 146]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Tuiles', 'roof_tiles', 1.15, 1900, 1634, CN_MATERIAL_TYPE_FACING, [204, 128, 128]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Ardoise', 'stone_tiles', 1.15, 1900, 1634, CN_MATERIAL_TYPE_FACING, [110, 110, 110]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Bois', 'wood_tiles', 1.15, 1900, 1634, CN_MATERIAL_TYPE_FACING, [165, 132, 80]));

        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Plâtre', 'gypsum_ceiling', 0.38, 900, 1008, CN_MATERIAL_TYPE_CEILING, [230, 230, 230]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Fibre minérale', 'fiber_ceiling', 0.038, 160, 2100, CN_MATERIAL_TYPE_CEILING, [200, 200, 230]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'PVC', 'pvc_ceiling', 0.038, 160, 2100, CN_MATERIAL_TYPE_CEILING, [200, 200, 200]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Bois', 'wood_ceiling', 0.14, 500, 2500, CN_MATERIAL_TYPE_CEILING, [165, 132, 80]));
        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Polycarbonate', 'polycarbon_ceiling', 0.038, 160, 2100, CN_MATERIAL_TYPE_CEILING, [200, 200, 200]));

        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Plâtre', 'gypsum', 0.38, 900, 1008, CN_MATERIAL_TYPE_LIGHT_STRUCTURE, [230, 230, 230]));

        CN_MATERIALS_TYPES.push(new cn_material_type(building, 'Inconnu', 'unknown', 0, 0, 0, CN_MATERIAL_TYPE_HEAVY_STRUCTURE));
    }

    //***********************************************************************************
    /**
     * Returns a default material type by code
     * @param {string} code
     * @return {cn_material_type}
     */
    static material_type_by_code(code) {
        for (let i in CN_MATERIALS_TYPES) {
            if (CN_MATERIALS_TYPES[i].code != code) continue;
            return CN_MATERIALS_TYPES[i].clone();
        }
        console.error('Could not find material type \'' + code + '\'');
        return null;
    }

    //***********************************************************************************
    //**** Clone
    //***********************************************************************************
    /**
     * @returns {cn_material_type}
     */
    clone() {
        const c = new cn_material_type(this.parent);
        c.name = this.name;
        c.code = this.code;
        c.type = this.type;
        c.conductivity = this.conductivity;
        c.density = this.density;
        c.specific_heat = this.specific_heat;
        c.color = this.color;
        c.custom = this.custom;
        c.thickness = this.thickness;
        c.extension_data = this.extension_data || {};
        return c;
    }

    //***********************************************************************************
    //**** keys
    //***********************************************************************************
    model_keys() {
        return ['name', 'code', 'type', 'conductivity', 'density', 'specific_heat', 'color', 'custom', 'thickness', 'extension_data'];
    }

    //***********************************************************************************
    //**** serialize
    //***********************************************************************************
    serialize() {
        const json = this.serialize_element();
        json.class_name = 'cn_material_type';
        json.custom = this.custom || false;
        json.name = this.name;
        json.code = this.code;
        json.type = this.type;
        json.conductivity = this.conductivity;
        json.density = this.density;
        json.specific_heat = this.specific_heat;
        json.color = this.color;
        json.thickness = this.thickness;
        json.extension_data = this.extension_data;
        return json;
    }

    static unserialize(json, building) {
        const mat = new cn_material_type(building);
        mat.unserialize_element(json);
        mat.custom = json.custom || false;
        mat.name = json.name;
        mat.code = json.code;
        mat.type = json.type;

        if (mat.type == null) {
            // for backward compatibility, because type was not set directly in material
            const ref = CN_MATERIALS_TYPES.find(it => it.code == mat.code);
            if (ref) {
                mat.type = ref.type;
            }
        }

        mat.conductivity = json.conductivity;
        mat.density = json.density;
        mat.specific_heat = json.specific_heat;
        mat.color = json.color;
        mat.thickness = json.thickness;
        mat.extension_data = json.extension_data || {};

        return mat;
    }

    //***********************************************************************************
    //**** returns label
    //***********************************************************************************
    get_label() {
        let result = this.name;
        if (this.thickness) {
            result = `${result} ${Number((this.thickness * 100).toFixed(2))} cm`;
        }
        return result;
    }

    get_generic_label() {
        return 'Matériau';
    }

    //***********************************************************************************
    //**** draw
    //***********************************************************************************
    draw_material(origin, width, height, scale) {
        if (width <= 0) return '';
        if (height <= 0) return '';

        let html = '';
        let color = this.color;
        /*[200,200,200];
        if (this.code == "brick")
            color = [150,20,20];
        else if (this.code == "stone")
            color = [182,171,136];
        else if (this.code == "wood" || this.code == "insulated_wood" || this.code == "tiles" || this.code == "wood_tiles")
            color = [165,132,80];
        else if (this.code == "steel" || this.code == "insulated_steel")
            color = [70,70,70];
        else if (this.code == "insulator")
            color = [236,233,183];
        else if (this.code == "wood_fiber")
            color = [158,220,121];
        else if (this.code == "styrofoam")
                color = [255,255,255];
        else if (this.code == "roof_tiles")
            color = [177,62,62];
        else if (this.code == "stone_tiles")
            color = [110,110,110];
        else if (this.code == "gypsum")
            color = [230,230,230];
        else if (this.code == "air_layer")
            color = [230,230,255];*/

        html += '<rect x=\'' + origin[0] + '\' y=\'' + origin[1] + '\' width=\'' + width + '\' height=\'' + height + '\' style=\'fill:rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ');stroke:none;\' />';

        if (this.code == 'block') {
            for (let y = 0; y < height; y += 0.2 * scale)
                html += '<line x1=\'' + origin[0] + '\' y1=\'' + y + '\' x2=\'' + (origin[0] + width) + '\' y2=\'' + y + '\' style=\'stroke:black;\' />';
        } else if (this.code == 'brick') {
            for (let y = 0; y < height; y += 0.1 * scale)
                html += '<line x1=\'' + origin[0] + '\' y1=\'' + y + '\' x2=\'' + (origin[0] + width) + '\' y2=\'' + y + '\' style=\'stroke:black;\' />';
        } else if (this.code == 'stone') {
            let offset = 5;
            for (let y = 0; y < height; y += 0.2 * scale) {
                html += '<line x1=\'' + origin[0] + '\' y1=\'' + (y - offset) + '\' x2=\'' + (origin[0] + width) + '\' y2=\'' + (y + offset) + '\' style=\'stroke:black;\' />';
                offset = -offset;
            }
        } else if (this.code == 'wood' || this.code == 'insulated_wood') {
            const thk_x = 0.02 * scale;
            const thk_y = 0.04 * scale;
            if (this.code == 'insulated_wood')
                color = [236, 233, 183];
            else
                color = [82, 66, 40];
            for (let y = 0; y < height; y += 0.4 * scale) {
                html += '<rect x=\'' + (origin[0] + thk_x) + '\' y=\'' + (y + thk_y) + '\' width=\'' + (width - thk_x) + '\' height=\'' + (0.4 * scale - thk_y) + '\' style=\'fill:rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ');stroke:none;\' />';
            }
        } else if (this.code == 'steel' || this.code == 'insulated_steel') {
            {
                const thk_x = 0;
                const thk_y = 0.15 * scale;
                if (this.code == 'insulated_steel')
                    color = [236, 233, 183];
                else
                    color = [150, 150, 150];
                for (let y = -0.5 * thk_y; y < height; y += 0.4 * scale) {
                    html += '<rect x=\'' + (origin[0] + thk_x) + '\' y=\'' + (y + thk_y) + '\' width=\'' + (width - thk_x) + '\' height=\'' + (0.4 * scale - thk_y) + '\' style=\'fill:rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ');stroke:none;\' />';
                }
            }
            {
                const thk_x = 0.03 * scale;
                const thk_y = 0.04 * scale;
                for (let y = -0.5 * thk_y; y < height; y += 0.4 * scale) {
                    html += '<rect x=\'' + (origin[0] + thk_x) + '\' y=\'' + (y + thk_y) + '\' width=\'' + (width - 2 * thk_x) + '\' height=\'' + (0.4 * scale - thk_y) + '\' style=\'fill:rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ');stroke:none;\' />';
                }
            }
        } else if (this.code == 'insulated_concrete') {
            const thk_x = scale * 0.05;
            const thk_dx = width - (thk_x * 2);
            const thk_y = 0.05 * scale;
            const thk_dy = 0.2 * scale;
            color = [236, 233, 183];
            for (let y = 0; y < height; y += thk_dy + 2 * thk_y) {
                html += '<rect x=\'' + (origin[0] + thk_x) + '\' y=\'' + (y + thk_y) + '\' width=\'' + thk_dx + '\' height=\'' + thk_dy + '\' style=\'fill:rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ');stroke:none;\' />';
            }
        } else if (this.type == CN_MATERIAL_TYPE_INSULATOR && this.code != 'air_layer') {
            html += '<path d=\'M ' + origin[0] + ' ' + origin[1] + ' ';

            const pattern = width / 2;
            for (let y = 0; y < height; y += pattern * 2) {
                html += 'Q ' + origin[0] + ' ' + (y + pattern) + ' ';
                html += ' ' + (origin[0] + width * 0.5) + ' ' + (y + pattern * 0.5) + ' ';
                html += 'Q ' + (origin[0] + width) + ' ' + y + ' ';
                html += ' ' + (origin[0] + width) + ' ' + (y + pattern) + ' ';
                html += 'Q ' + (origin[0] + width) + ' ' + (y + pattern * 2) + ' ';
                html += ' ' + (origin[0] + width * 0.5) + ' ' + (y + pattern * 1.5) + ' ';
                html += 'Q ' + origin[0] + ' ' + (y + pattern) + ' ';
                html += ' ' + origin[0] + ' ' + (y + pattern * 2) + ' ';
            }
            html += '\' style=\'fill: none;stroke:black;\' />';
        }
        return html;
    }
}

